.brandManagerApprovedDesignsTab {
  margin-left: auto;
  justify-self: flex-end;
}
